import EventEmitter from "events";

let config: any = {};

let configList: any = {
  emitter: new EventEmitter(),
  url: {
    home: "/",
  },
  apiUrl:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "development"
      ? "http://localhost:3001"
      : "https://plant.mofa.gov.mn"),
  sfsFileUrl: "https://support.mofa.gov.mn/FileCenter/RequestPath/",
};

config.config = function (data: any) {
  configList = {
    ...configList,
    ...data,
  };
};
config.get = function (option: string) {
  return configList[option];
};

export default config;
